var map = {
	"./QR.svg": 27932,
	"./QS-ic-file-color.svg": 80743,
	"./approval_mange.svg": 21621,
	"./approval_mange_active.svg": 89054,
	"./carManage.svg": 532,
	"./carManage_active.svg": 58561,
	"./car_to_lease.svg": 81060,
	"./car_to_lease_active.svg": 7921,
	"./checkRightHorn.svg": 29584,
	"./check_indeterminate.svg": 27571,
	"./checked.svg": 30332,
	"./circle-mark.svg": 46585,
	"./company_new.svg": 24669,
	"./company_new_active.svg": 70390,
	"./contract.svg": 94359,
	"./contract_active.svg": 37168,
	"./customer.svg": 84261,
	"./customer_active.svg": 42734,
	"./dashboard.svg": 57063,
	"./dashboard_active.svg": 51648,
	"./driver.svg": 5883,
	"./driver_active.svg": 92780,
	"./eye.svg": 83308,
	"./finance.svg": 55453,
	"./finance_active.svg": 21622,
	"./form.svg": 32603,
	"./hastenDebt.svg": 51903,
	"./hastenDebt_active.svg": 40584,
	"./ic-unbinding.svg": 37222,
	"./link.svg": 10277,
	"./logCenter.svg": 3474,
	"./logCenter_active.svg": 98879,
	"./message.svg": 48630,
	"./open-eye.svg": 95997,
	"./organization.svg": 68676,
	"./organization_active.svg": 64177,
	"./password.svg": 61854,
	"./purchase_new.svg": 43175,
	"./purchase_new_active.svg": 70624,
	"./return_lease.svg": 20104,
	"./return_lease_active.svg": 69741,
	"./riskControl.svg": 5280,
	"./riskControl_active.svg": 71156,
	"./send email.svg": 43111,
	"./service.svg": 78834,
	"./service_active.svg": 64959,
	"./tenant_new.svg": 28230,
	"./tenant_new_active.svg": 78987,
	"./todo-count.svg": 34283,
	"./unchecked.svg": 66151,
	"./under_lease.svg": 33650,
	"./under_lease_active.svg": 82271,
	"./user-menu.svg": 26424,
	"./user-new.svg": 341,
	"./user.svg": 84432,
	"./vehicle.svg": 40763,
	"./vehicle_active.svg": 89356,
	"./wechat-oa.svg": 72972,
	"./wid-arrow-right.svg": 92934,
	"./workbench.svg": 80172,
	"./workbench_active.svg": 95945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;